import { getProviderOutreach } from "@/lib/core/provider-contact.server.ts";
import { createServerFn } from "@tanstack/react-start";
import type { BoundaryUnknown } from "@wags/utils/boundary-unknown.ts";
import { resolveContactLinkPreviewRequestSchema } from "@wags/profile-contracts/contact-session.contract.ts";
import { getCatalog } from "@/lib/core/catalog-core.server";
import { contactLinkPreview } from "./contact-link-shell";

export const resolveContactLinkPreview = createServerFn({ method: "POST" })
    .inputValidator((value: BoundaryUnknown) =>
        resolveContactLinkPreviewRequestSchema.parse(value),
    )
    .handler(async ({ data }) => {
        const outreach = await getProviderOutreach();
        const live = await outreach.resolveLiveProviderContactListingByToken({
            token: data.token,
        });
        if (!live) return null;
        const catalog = await getCatalog();
        const [listing] = await catalog.listings.getListingsByIds([
            live.listingId,
        ]);
        return contactLinkPreview(listing);
    });

export function loadContactLinkPreview(token: string) {
    const request = resolveContactLinkPreviewRequestSchema.safeParse({ token });
    return request.success
        ? resolveContactLinkPreview({ data: request.data })
        : null;
}
